// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Q3CDY","arrowButton":"styles_arrowButton__mGw6d","tableHeader":"styles_tableHeader__l5j+N","summary":"styles_summary__fLWVt"};